const SortIcon = ({ fill = "#374151" }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill={fill} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1 3C1 2.725 1.225 2.5 1.5 2.5H14.5C14.775 2.5 15 2.725 15 3C15 3.275 14.775 3.5 14.5 3.5H1.5C1.225 3.5 1 3.275 1 3ZM1 8C1 7.725 1.225 7.5 1.5 7.5H10.5C10.775 7.5 11 7.725 11 8C11 8.275 10.775 8.5 10.5 8.5H1.5C1.225 8.5 1 8.275 1 8ZM7 13C7 13.275 6.775 13.5 6.5 13.5H1.5C1.225 13.5 1 13.275 1 13C1 12.725 1.225 12.5 1.5 12.5H6.5C6.775 12.5 7 12.725 7 13Z"
      fill={fill}
    />
  </svg>
);

export default SortIcon;
